import axios from 'axios';

const MAIN_API_URL = process.env.REACT_APP_MAIN_API_URL;
const MAIN_API_KEY = process.env.REACT_APP_MAIN_API_KEY;

const BLOG_API_URL = process.env.REACT_APP_BLOG_API_URL;
const BLOG_API_KEY = process.env.REACT_APP_BLOG_API_KEY;

const BLOG_ROUTES = ['/blogs', '/news', '/agents', '/youtube-videos'];



axios.interceptors.request.use(
  (config) => {
    const localstore = localStorage.getItem('bingold');

    if (localstore) {
      try {
        const parsed = JSON.parse(localstore);
        const token = parsed?.token;
        if (token) {
          config.headers.Authorization = `Bearer ${token}`;
        }
      } catch (e) {
        console.error('Failed to parse token', e);
      }
    }

    const isBlogApi = BLOG_ROUTES.some((route) =>
      config.url?.startsWith(route)
    );

    if (isBlogApi) {
      config.baseURL = BLOG_API_URL;
      config.headers['x-api-key'] = BLOG_API_KEY;
    } else {
      config.baseURL = MAIN_API_URL;
      config.headers['x-api-key'] = MAIN_API_KEY;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

export default axios;
